import { findDOMNode } from 'react-dom';

/* eslint-disable no-undef */
const focusableElSelectors = [
  '[role="button"]',
  '[tabindex="0"]',
  'a[href]',
  'button',
  'textarea',
  'input',
  'select',
  '[contenteditable]',
].join(', ');

/**
 * To focus the first focusable element
 * @param {string} id
 * @param {Ref} ref
 * @returns {boolean}
 */
export const focusFirst = ({ id, ref }) => {
  if (!id && !ref) return false;
  const element = id ? document.getElementById(id) : findDOMNode(ref.current);
  if (!element) return false;
  setTimeout(() => {
    const focusableEls = element.querySelectorAll(focusableElSelectors);
    const firstElement = focusableEls[0];
    if (firstElement) firstElement.focus();
  }, 0);
  return true;
};

/**
 * To trap focus in the target container
 * @param {string} id
 * @param {boolean} initialFocus
 * @returns {Function | boolean}
 */
export const trapFocus = ({ id, initialFocus = true }) => {
  const element = document.getElementById(id);
  if (!element) return false;

  const endElement = document.getElementById(`${id}-end`);
  if (endElement) {
    element.removeChild(endElement);
  }
  const fElement = document.getElementById(`${id}-first`);
  if (fElement) {
    element.removeChild(fElement);
  }

  const focusableEls = element.querySelectorAll(focusableElSelectors);
  const firstElement = focusableEls[0];
  const lastElement = focusableEls[focusableEls.length - 1];

  const firstListener = () => lastElement && lastElement.focus();
  const lastListener = () => firstElement && firstElement.focus();

  const endDiv = document.createElement('div');
  endDiv.setAttribute('id', `${id}-end`);
  endDiv.setAttribute('role', 'button');
  endDiv.setAttribute('tabindex', 0);
  endDiv.setAttribute('aria-hidden', true);
  endDiv.addEventListener('focus', lastListener);
  element.appendChild(endDiv);

  const firstDiv = document.createElement('div');
  firstDiv.setAttribute('id', `${id}-first`);
  firstDiv.setAttribute('tabindex', 0);
  firstDiv.setAttribute('role', 'button');
  firstDiv.setAttribute('aria-hidden', true);
  firstDiv.addEventListener('focus', firstListener);
  element.insertBefore(firstDiv, element.children[0]);

  if (initialFocus) {
    setTimeout(() => firstElement && firstElement.focus(), 0);
  }

  return () => {
    endDiv.removeEventListener('focus', lastListener);
    endDiv.remove();
    firstDiv.removeEventListener('focus', lastListener);
    firstDiv.remove();
  };
};



// WEBPACK FOOTER //
// ./src/client/utils/focusUtils.js